export default "__VITE_ASSET__uM8_yzep__"